import React, { useContext, useEffect, useState } from "react";
import { FaTrash } from "react-icons/fa";
import axiosClient from "../../../Services/Axios/axios";
import PhoneInput from "react-country-phone-input";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { BeatLoader } from "react-spinners";
import { organizationDetail } from "../../../Context/SelectedOrganization";

const EmailSentInvitation = () => {
  const navigate = useNavigate();
  const [membersEmail, setMembersEmail] = useState([
    {
      name: "",
      email: "",
      contact: "",
      fullMobile: "",
      mobile_no: "",
      mobileCode: "",
      role_id: "",
    },
  ]);
  const [loading, setLoading] = useState(false);
  const [roles, setRoles] = useState([]);
  const { organizationData } = useContext(organizationDetail);
  const [singleOrganization, setSingleOrganization] = useState({});
  const [errorsValidation, setErrorsValidation] = useState([]);
  const [emailSuggestions, setEmailSuggestions] = useState([]);
  // Update any field for a member
  const updateField = (index, field, value) => {
    const updated = [...membersEmail];
    updated[index][field] = value;
    setMembersEmail(updated);

    // remove errors live
    const newErrors = [...errorsValidation];
    if (newErrors[index]) {
      newErrors[index][field] = "";
      setErrorsValidation(newErrors);
    }
  };

  // Phone update per-member
  const handleMobileChange = (index, value, country) => {
    const updated = [...membersEmail];
    updated[index].fullMobile = value;
    updated[index].mobile_no = value.slice(country.dialCode.length);
    updated[index].mobileCode = `+${country.dialCode}`;
    setMembersEmail(updated);

    const newErrors = [...errorsValidation];
    if (newErrors[index]) {
      newErrors[index].contact = "";
      setErrorsValidation(newErrors);
    }
  };

  const emailHintVerify = async (email) => {
    if (!email) {
      setEmailSuggestions([]);
      return;
    }

    try {
      const response = await axiosClient.post(
        `employees/${process.env.REACT_APP_API_VERSION}/employee-hint`,
        {
          search: email,
        }
      );

      if (!response.data.error) {
        // API se jo array aa raha hai
        setEmailSuggestions(response.data.data || []);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const debounce = (func, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => func(...args), delay);
    };
  };
  const debouncedEmailVerify = debounce((email) => {
    emailHintVerify(email);
  }, 500);

  // Add new member
  const handleAddMember = () => {
    setMembersEmail([
      ...membersEmail,
      {
        name: "",
        email: "",
        contact: "",
        fullMobile: "",
        mobile_no: "",
        mobileCode: "",
        role_id: "",
      },
    ]);
  };

  // Remove member
  const handleRemoveMember = (index) => {
    if (membersEmail.length > 1) {
      setMembersEmail(membersEmail.filter((_, i) => i !== index));
    }
  };

  // SUBMIT WITH FULL VALIDATION
  const handleSubmit = async () => {
    let isValid = true;
    let newErrors = [];

    membersEmail.forEach((member, index) => {
      let err = {};

      // NAME VALIDATION
      if (!member.name?.trim()) {
        err.name = "Name is required";
        isValid = false;
      }

      // EMAIL VALIDATION
      if (!member.email?.trim()) {
        err.email = "Email is required";
        isValid = false;
      } else {
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailRegex.test(member.email)) {
          err.email = "Enter a valid email";
          isValid = false;
        }
      }

      // CONTACT VALIDATION
      if (!member.mobile_no || member.mobile_no.trim() === "") {
        err.contact = "Contact number is required";
        isValid = false;
      } else if (member.mobile_no.length < 7) {
        err.contact = "Enter valid contact number";
        isValid = false;
      }

      // ROLE VALIDATION
      if (!member.role_id) {
        err.role_id = "Role is required";
        isValid = false;
      }

      newErrors[index] = err;
    });

    setErrorsValidation(newErrors);

    if (!isValid) {
      return;
    }
    try {
      setLoading(true);
      // ----------------------------------------------------------
      // ⭐ CREATE COMMON FORMAT DATA
      // ----------------------------------------------------------
      const formattedMembers = membersEmail.map((m) => ({
        role_id: Number(m.role_id),
        name: m.name,
        email: m.email,
        phone: m.fullMobile,
        invitation_type: "email",
        invite_code: "",
        invite_link: "",
        invite_qr: "",
        status: 0,
      }));

      // ----------------------------------------------------------
      // ⭐ CONDITION: single = object, multiple = array
      // ----------------------------------------------------------
      const finalPayload = {
        organization_id: sessionStorage.getItem("organization_id"),
        employees: formattedMembers,
      };

      // ----------------------------------------------------------
      // ⭐ API CALL
      // ----------------------------------------------------------
      const response = await axiosClient.post(
        `employees/${process.env.REACT_APP_API_VERSION}/create`,
        finalPayload
      );
      if (!response.data.error) {
        setLoading(false);
        Swal.fire({
          icon: "success",
          title: response.data.message || " Invitation sent successfully",
        });
        navigate("/employees");
      } else {
        setLoading(false);
        Swal.fire({
          icon: "error",
          title: response.data.message || "Something went wrong",
        });
      }
    } catch (error) {
      setLoading(false);
      Swal.fire({
        icon: "error",
        title: "Failed to update profile",
        text: error?.response?.data?.message || "Something went wrong",
      });
    } finally {
      setLoading(false);
    }
  };
  // Fetch roles
  const getUserList = async () => {
    try {
      const response = await axiosClient.get(
        `employees/${
          process.env.REACT_APP_API_VERSION
        }/role/role-lists?organization_id=${sessionStorage.getItem(
          "organization_id"
        )}`
      );

      if (!response.data.error) {
        setRoles(
          response.data.data.rows.map((item) => ({
            id: item.id,
            value: item.role_name,
          }))
        );
      }
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    getUserList();
    setSingleOrganization(organizationData);
  }, [organizationData]);
  if (loading)
    return (
      <div className="loader">
        <BeatLoader color="#097C81" />
      </div>
    );
  return (
    <div className="form_boxx profilss p-4">
      <p>
        Add members via email. After clicking send, members receive an email
        notification.
      </p>

      {membersEmail.map((m, i) => (
        <div key={i} className="member-block">
          <div className="d-flex justify-content-between mb-3">
            <h5>Member–{i + 1}</h5>

            <div className="d-flex align-items-center">
              {i > 0 && (
                <button
                  className="delete-btns"
                  onClick={() => handleRemoveMember(i)}
                >
                  <FaTrash size={18} />
                </button>
              )}

              <button className="add-btn ml-1" onClick={handleAddMember}>
                +
              </button>
            </div>
          </div>

          <div className="row">
            {/* NAME */}
            <div className="col-lg-6 mb-3">
              <label>Name</label>
              <input
                value={m.name}
                placeholder="Enter name"
                className={`form-control ${
                  errorsValidation?.[i]?.name ? "input-error" : ""
                }`}
                onChange={(e) => updateField(i, "name", e.target.value)}
              />
              {errorsValidation?.[i]?.name && (
                <span className="error">{errorsValidation[i].name}</span>
              )}
            </div>

            {/* EMAIL */}
            <div className="col-lg-6 mb-3">
              <label>Email</label>

              <div className="suggestion-wrapper">
                <input
                  value={m.email}
                  placeholder="Enter email"
                  className={`form-control ${
                    errorsValidation?.[i]?.email ? "input-error" : ""
                  }`}
                  onChange={(e) => {
                    const emailVal = e.target.value;
                    updateField(i, "email", emailVal);
                    debouncedEmailVerify(emailVal);
                  }}
                />

                {/* ✅ Custom suggestion dropdown */}
                {emailSuggestions.length > 0 && (
                  <ul className="suggestion-box">
                    {emailSuggestions.map((item, index) => (
                      <li
                        key={index}
                        onClick={() => {
                          updateField(i, "email", item.email);
                          setEmailSuggestions([]); // hide dropdown
                        }}
                      >
                        {item.email}
                      </li>
                    ))}
                  </ul>
                )}
              </div>

              {errorsValidation?.[i]?.email && (
                <span className="error">{errorsValidation[i].email}</span>
              )}
            </div>

            {/* CONTACT */}
            <div className="col-lg-6 mb-3">
              <label>Contact No.</label>
              <PhoneInput
                key={`phone-${i}`} // 🔥 FIX 1
                inputId={`phone-${i}`} // 🔥 FIX 2
                className={`react-tel-input ${
                  errorsValidation?.[i]?.contact ? "input-error" : ""
                }`}
                placeholder="Enter Phone Number"
                country={"th"}
                value={m.fullMobile || "+66"}
                onChange={(value, country) =>
                  handleMobileChange(i, value, country)
                }
              />
              {errorsValidation?.[i]?.contact && (
                <span className="error">{errorsValidation[i].contact}</span>
              )}
            </div>

            {/* ROLE */}
            <div className="col-lg-6 mb-3">
              <label>Role type</label>
              <select
                className={`form-control ${
                  errorsValidation?.[i]?.role_id ? "input-error" : ""
                }`}
                value={m.role_id}
                onChange={(e) => updateField(i, "role_id", e.target.value)}
              >
                <option value="">Select a Role</option>
                {roles.map((res) => (
                  <option key={res.id} value={res.id}>
                    {res.value}
                  </option>
                ))}
              </select>
              {errorsValidation?.[i]?.role_id && (
                <span className="error">{errorsValidation[i].role_id}</span>
              )}
            </div>
          </div>
        </div>
      ))}

      <div className="invite-send">
        <button
          className="invite-btns cancel"
          onClick={() => navigate("/employees")}
        >
          Cancel
        </button>
        <button className="invite-btns send" onClick={handleSubmit}>
          Send
        </button>
      </div>
    </div>
  );
};

export default EmailSentInvitation;
